import { Sync } from '@mui/icons-material';
import axios from 'axios';
import { ButtonAction, FieldFactory, Resource } from '@/classes';
import { ProductCollection, productCollectionPayloadSchema } from '@/types';

export default function productCollections() {
  return new Resource<ProductCollection>('Product Collections')
    .withSchema(productCollectionPayloadSchema)
    .withIndexActions([
      new ButtonAction('Ingest Products', () => {
        axios.post(`/api/product-collections/ingest`);
      }).withIcon(Sync),
    ])
    .withFieldsAndColumns([
      FieldFactory.text('name'),
      FieldFactory.textarea('description'),
      FieldFactory.image('image'),
      FieldFactory.belongsTo('parent', 'productCollections'),
      FieldFactory.hasMany('tags', 'productTags'),
      FieldFactory.number('sort_order'),
    ]);
}
